<footer>
  <div class="container-footer">
    <div class="contact-info">
      <div class="item">
        <p>
          <strong>{{ 'HOME.CONTACT_FORM.EMAIL' | translate }}</strong>
        </p>
        <p>contactenos&#64;calia.com.co</p>
      </div>
      <div class="item">
        <p>
          <strong>{{ 'FOOTER.TELEPHONE' | translate }}</strong>
        </p>
        <p>(+57) 320 5852710</p>
      </div>
    </div>
    <p class="copyright">
      <strong>© {{ currentYear }} Calia Tech</strong>
      . {{ 'FOOTER.ALL RIGHTS RESERVED' | translate }}
    </p>
  </div>
</footer>
